import runtimeConfig from '../../../config/runtimeConfig';

const defParams = {
    percent: {
        style: 'percent',
        minimumFractionDigits: runtimeConfig.percentDecimalFixedValue || 2,
        maximumFractionDigits: runtimeConfig.percentDecimalFixedValue || 2
    },
    percentage: {
        style: 'percent'
    },
    currency: {
        default: {
            style: 'currency'
        },
        USD: {
            minimumFractionDigits: 4
        },
        EUR: {
            minimumFractionDigits: 4
        },
        UST: {
            minimumFractionDigits: 4
        },
        RON: {
            minimumFractionDigits: 4
        },
        UAH: {
            minimumFractionDigits: 4
        },
        INR: {
            minimumFractionDigits: 4
        }
    },
    currencyBalance: {
        default: {
            style: 'currency'
        },
        USD: {
            minimumFractionDigits: 2
        },
        EUR: {
            minimumFractionDigits: 2
        },
        UST: {
            minimumFractionDigits: 2
        },
        RON: {
            minimumFractionDigits: 2
        },
        UAH: {
            minimumFractionDigits: 2
        },
        INR: {
            minimumFractionDigits: 2
        }
    },
    date: {},
    dateTime: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    },
    fullDateTime: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    },
    dateMonth: {
        year: 'numeric',
        month: 'long'
    },
    dateYear: {
        year: 'numeric'
    }
};

export default defParams;
